import { render, staticRenderFns } from "./document-form.vue?vue&type=template&id=1bea79c1&scoped=true&"
import script from "./document-form.vue?vue&type=script&lang=js&"
export * from "./document-form.vue?vue&type=script&lang=js&"
import style0 from "./document-form.vue?vue&type=style&index=0&id=1bea79c1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bea79c1",
  null
  
)

export default component.exports